import { useModal, ButtonColor } from '@ampol/design-system';

interface ConfirmStatusModalProps {
  status: string;
  onConfirm: () => void;
}

/**
 * This modal is used to confirm a status update on a card when
 * the specified status doesn't require replacement options.
 * eg. Active, Closed, Temporary Closed.
 */
const useConfirmStatusModal = (props: ConfirmStatusModalProps) => {
  const modal = useModal({
    color: ButtonColor.Blue,
    title: 'Update status?',
    id: 'update-status-modal',
    variant: 'double',
    content: (
      <p>{`You've set your card status to ${props.status}. Do you wish to proceed?`}</p>
    ),
    actions: [
      {
        label: 'Yes',
        onClick: () => props.onConfirm(),
      },
      {
        label: 'No',
        onClick: () => modal.close(),
      },
    ],
  });

  return modal;
};

export default useConfirmStatusModal;
